import { ClientLocaleNS } from 'lib/constants/locales'

import commonJSON from './common.json'
import homePageJSON from './home_page.json'
import errorPageJSON from './error_page.json'
import refundPageJSON from './refund_page.json'
import privacyPageJSON from './privacy_page.json'
import policyddaPageJSON from './policydda_page.json'
import checkoutPageJSON from './checkout_page.json'
import publicOfferPageJSON from './public_offer.json'

const resource = {
  [ClientLocaleNS.Common]: commonJSON,
  [ClientLocaleNS.HomePage]: homePageJSON,
  [ClientLocaleNS.ErrorPage]: errorPageJSON,
  [ClientLocaleNS.RefundPage]: refundPageJSON,
  [ClientLocaleNS.PrivacyPage]: privacyPageJSON,
  [ClientLocaleNS.PolicyddaPage]: policyddaPageJSON,
  [ClientLocaleNS.CheckoutPage]: checkoutPageJSON,
  [ClientLocaleNS.PublicOfferPage]: publicOfferPageJSON,
}

export default resource
